import { render, staticRenderFns } from "./UpdateChannelDialog.vue?vue&type=template&id=9ce6f5ce&scoped=true&lang=pug&"
import script from "./UpdateChannelDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateChannelDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce6f5ce",
  null
  
)

export default component.exports